import { BTSelectItem } from "types/apiResponse/apiResponse";

import { type CategoryType } from "entity/category/common/categoryType";

export class CategoryEntity {
    constructor(data: any) {
        this.id = data.id;
        this.categoryType = data.categoryType;
        this.title = data.title;
        this.categoryColor = data.categoryColor;
        this.categoryIcon = data.categoryIcon;
    }
    id: number;
    categoryType: CategoryType;
    title: string;
    categoryColor?: string;
    categoryIcon?: number;
}

export interface ICategoryDetails {
    id?: number;
    categoryFriendlyName: string;
    categoryTitle: string;

    onDeleteMessage: string;
    isAssociatedWithEntity: boolean;
    canDelete: boolean;
    canEdit: boolean;
    showLeadActivity: boolean;
}

export interface ILeadActivityCategoryDetails extends ICategoryDetails {
    leadActivityColor: string;
    leadActivityIcons: BTSelectItem[];
}

export const isLeadActivityCategoryDetails = (
    details: ICategoryDetails | ILeadActivityCategoryDetails,
): details is ILeadActivityCategoryDetails => details.showLeadActivity;

export class CategoryDetails implements ICategoryDetails, ILeadActivityCategoryDetails {
    constructor(data: any) {
        this.id = data.id;
        this.categoryFriendlyName = data.categoryFriendlyName;
        this.categoryTitle = data.categoryTitle;
        this.onDeleteMessage = data.onDeleteMessage;
        this.isAssociatedWithEntity = data.isAssociatedWithEntity;
        this.canDelete = data.canDelete;
        this.canEdit = data.canEdit;

        this.showLeadActivity = data.showLeadActivity;
        this.leadActivityColor = data.leadActivityColor;
        this.leadActivityIcons =
            data.leadActivityIcons && data.leadActivityIcons.map((i: any) => new BTSelectItem(i));
    }

    id?: number;
    categoryFriendlyName: string;
    categoryTitle: string;

    showLeadActivity: boolean;
    leadActivityColor: string;
    leadActivityIcons: BTSelectItem[];

    onDeleteMessage: string;
    isAssociatedWithEntity: boolean;
    canDelete: boolean;
    canEdit: boolean;
}

export class CategoryDeleteResponse {}

export enum CategoryDetailsActions {
    Add = 0,
    Edit = 1,
    Delete = 2,
}
